const formatUserRoleText = (role) => {
  return role === "administrator"
    ? "Administrator"
    : role === "edit"
    ? "Editor"
    : role === "view"
    ? "Observer"
    : "";
};

export { formatUserRoleText };
